import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Tooltip, Typography, Space } from 'antd';
import '../globalStyling/responsive.css';

// Global Styles
import { PageTitleText, TooltipText } from '../../shared/globalStyling/styledText';
import { space, fontSize as fontSizeTokens, text, border } from '../../ux/Tasks/configs/designTokens';

const styles = {
  container: {
    minHeight: space[16],
    background: '#ffffff',
    border: `1px solid ${border.light}`,
    padding: `0 ${space[5]}px`,
  },
  title: {
    height: '100%',
    fontSize: fontSizeTokens.body,
  },
};

const { Text } = Typography;

const PageHeaderLayout = ({
  title,
  titleIcon,
  titleExtra,
  centerContent,
  rightContent,
  topBorderOff,
  style,
  tag,
  subtitle,
  titleRightIcon,
  titleDescription,
  tabContent,
}) => {
  // prevents description to be "null"
  titleDescription =
    titleDescription === null || titleDescription === undefined || titleDescription === 'null'
      ? ''
      : titleDescription;
  return (
    <Row
      className="ant-row-flex-column ant-row-align-items-center"
      type="flex"
      justify="space-between"
      align="start"
      style={{
        ...styles.container,
        ...styles.title,
        ...style,
        borderTop: topBorderOff ? 0 : `1px solid ${border.light}`,
      }}
    >
      {title &&
        (typeof title === 'string' ? (
          <>
            {title.length > 45 ? (
              <Tooltip title={<TooltipText text={title} />}>
                <Space className="ant-space-xs-vertical ant-space-md-horizontal">
                  {titleIcon && titleIcon}
                  <Space direction="vertical" size={0}>
                    <PageTitleText text={title} />
                    <Text type="secondary">{titleDescription}</Text>
                  </Space>
                  {tag}
                  {titleRightIcon ? titleRightIcon : null}
                  <Text type="secondary">{subtitle}</Text>
                  {titleExtra ? titleExtra : null}
                </Space>
              </Tooltip>
            ) : (
              <>
                <Space className="ant-space-xs-vertical ant-space-md-horizontal">
                  {titleIcon && titleIcon}
                  <Space direction="vertical" size={0}>
                    <PageTitleText text={title} />
                    <Text type="secondary">{titleDescription}</Text>
                  </Space>
                  {tag}
                  {titleRightIcon ? titleRightIcon : null}
                  <Text type="secondary">{subtitle}</Text>
                  {titleExtra ? titleExtra : null}
                </Space>
              </>
            )}
          </>
        ) : (
          <Col>
            <div>{title}</div>
          </Col>
        ))}
      {centerContent && (
        <Col>
          <div>{centerContent}</div>
        </Col>
      )}
      {rightContent && (
        <Col style={{ display: 'flex', alignItems: 'center' }}>
          <div>{rightContent}</div>
        </Col>
      )}
      {tabContent}
    </Row>
  );
};
export default PageHeaderLayout;

PageHeaderLayout.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  titleIcon: PropTypes.node,
  style: PropTypes.object,
  centerContent: PropTypes.node,
  rightContent: PropTypes.node,
  titleDescription: PropTypes.string,
  titleDescriptionStyle: PropTypes.object,
};
